/**
 *
 * Creates a cookie. Defaults to creating a session cookie unless `exp` is set.
 *
 * ```js
 * import { createCookie } from '@minerva-analytics/pantheon';
 *
 * createCookie(`jwt`, `lala.example`);
 * createCookie(`jwt`, `lala.example`, exp=2);
 * ```
 *
 * @param {string} key The key to store the cookie under
 * @param {string} value The value to store in the cookie
 * @param {Number} exp The expiry of the cookie in days
 *
 */
var createCookie = function createCookie(key, value, exp) {
  if (exp === void 0) {
    exp = null;
  }

  var expiresStr = "";

  if (exp !== null) {
    var date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    expiresStr = "; expires=" + date.toGMTString();
  }

  document.cookie = key + "=" + value + expiresStr + "; path=/";
};

export default createCookie;